module.exports = __webpack_public_path__ + "img/getcode-3.587f3102.png";